













































import {Vue, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import {htmlRestore} from '@/utils/formatUtils'
@Component({
  components: {
    PageTitle
  }
})
export default class ArticleMove extends Vue {
  private htmlRestore = htmlRestore
  private theForm: any = {
    name: '',
    boardNo: 'NONE',
    categoryNo: ''
  };
  private boards: any[] = [];
  private getBoards() {
    let obj = {
      params: {
        mallNo: Number(this.$route.query.mallNo)
      }
    };
    this.$api.getBoards(obj).then((res: any) => {
      this.boards = res.data;
      if(this.boards.length) {
        this.boards = this.boards.reverse();
      }
    });
  }
  private checkForm(): any {
    if ($('#board').val() == 'NONE') {
      alert(this.$t('BOARD_ARTICLE_MOVE_ALERT_ONE'));
      return false;
    }
    if ($('#category').attr('disabled') != 'disabled' && !$('#category').val()) {
      alert(this.$t('BOARD_ARTICLE_MOVE_ALERT_TWO'));
      return false;
    }
    return true;
  }
  private changeBoard() {
    this.theForm.categoryNo = '';
    let selectedBoardNo = $('#board').val();
    let selectedBoard = this.boards.filter(function(board: any) {
      return board.boardNo == selectedBoardNo;
    })[0];
    let categorySelect = $('#category');
    categorySelect.text('');
    categorySelect.append(`<option value="">${this.$t('BOARD_ARTICLE_MOVE_CATEGORY_NONE')}</option>`);
    if (selectedBoard && selectedBoard.categoryUsed) {
      categorySelect.removeAttr('disabled');
      selectedBoard.categories.forEach(function(category: any) {
        categorySelect.append('<option value="' + category.categoryNo + '">' + category.categoryName + '</option>');
      });
    } else {
      categorySelect.attr('disabled', 'disabled');
    }
  }
  private clickApplyButtons() {
    if (!this.checkForm()) return;
    let obj: any = {
      pathParams: {
        boardNo: Number(this.$route.query.boardNo)
      },
      data: {
        categoryNo: this.theForm.categoryNo,
        postNos: (this.$route.query.articleNumbers as string).split(','),
        mallNo: Number(this.$route.query.mallNo),
        boardNo: this.theForm.boardNo
      }
    };
    this.$api.putBoardsBoardNoPosts(obj).then((res: any) => {
      let response = res.data;
      var successMessage = response.successCount > 0 ? '성공' + response.successCount + '건: 게시글 이동 완료\r' : '';
      if (response.failureCount > 0) {
        var failMessage = '실패' + response.failureCount + '건:' + response.failureReasons;
        alert(successMessage + failMessage);
      } else {
        alert(successMessage);
      }
      $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback as string}(${JSON.stringify(response)});`);
      self.close();
    });
  }
  private clickCancelButton() {
    self.close();
  }
  private mounted() {
    this.theForm.name = this.$route.query.name;
    this.getBoards();
    this.changeBoard();
  }
}
